import Splide from '@splidejs/splide';

export default {
  init() {
    // JavaScript to be fired on the home page
    $('.toggle-overlay').on('click', function() {
      $('.overlay').toggle();
    });

    $('#js-btn-about').on('click', function () {
      $('.landing-about').toggleClass('visible');
      $('body, html').animate(
        {
          scrollTop: $('.landing-about').offset().top,
        },
        800 //speed
      );
    })

    if ($('.splide').length !== 0) {
      new Splide( '.splide', {
        type   : 'loop',
        perPage: 1,
        perMove: 1,
        speed: 800,
        pagination: false,
        gap: 15,
        fixedWidth: '100%',
        classes: {
          arrows: 'splide__arrows btn-arrows',
          arrow : 'splide__arrow btn-arrows',
          prev  : 'splide__arrow--prev btn-arrow-prev',
          next  : 'splide__arrow--next btn-arrow-next',
        },
      } ).mount();
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js